var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M9 2.531V1.125M4.423 4.423 3.43 3.43M2.531 9H1.125m3.298 4.577-.992.992m5.569.9v1.406m4.577-3.298.992.992m.9-5.569h1.406m-3.298-4.577.992-.992M13.219 9A4.219 4.219 0 1 1 4.78 9a4.219 4.219 0 0 1 8.438 0"
  })));
};
export default SvgSun;